import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MatInputModule} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {InputTextareaComponent} from './input-textarea.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        MatInputModule,
    ],
    declarations: [
        InputTextareaComponent,
    ],
    exports: [
        InputTextareaComponent,
    ],
})
export class InputTextareaModule {
}
